(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');

    /* service for requesting agenda labels */
    module.factory('AgendaLabelService', ['$http', 'SharedAgendaService', function ($http, SharedAgendaService) {
        var baseUrl = '/api/agendalabels/';

        var service = {
            query: query,
            get: get,
            deactivate: deactivate,
            update: update,
            save: save,
            getByAgendas: getByAgendas
        };

        return service;

        /* get agenda-labels of specific agenda */
        function query(agendaId, all) {
            return $http.get(baseUrl + 'agenda/' + agendaId + '/' + (all ? all : false) + '/false').then(function (result) {
                return result.data;
            });
        }

        /* get agenda label */
        function get(id) {
            return $http.get(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (result) {
                return result.data;
            });
        }

        /* deactivate agenda label */
        function deactivate(agendalabelId) {
            return $http.delete(baseUrl + agendalabelId + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (result) {
                return result.data;
            });
        }

        /* update agenda label */
        function update(agendalabelId, item) {
            return $http.put(baseUrl + agendalabelId + '/agendas/' + SharedAgendaService.data.currentAgenda.id, item).then(function (result) {
                return result.data;
            });
        }

        /* save agenda label */
        function save(item) {
            return $http.post(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id, item).then(function (result) {
                return result.data;
            });
        }

        /* get agenda labels for given agenda ids */
        function getByAgendas(agendaIds, removeReadonly, filterInFirstFreeAppointments) {
            return $http({
                url: baseUrl + 'agendas/' + (removeReadonly ? removeReadonly : false) +'/'+ (filterInFirstFreeAppointments ? filterInFirstFreeAppointments : false),
                method: 'GET',
                params: {
                    agendaIds: (agendaIds ? agendaIds : null)
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }]);

})();